(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["vorliva-purchase-confidence"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializePurchaseConfidence = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const items = [...root.querySelectorAll('[data-vpc-item]')];
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      root.classList.add('is-enhanced');
      items.forEach((item, index) => item.style.setProperty('--vpc-delay', `${index * 80}ms`));

      if ('IntersectionObserver' in window && !reduceMotion) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.22 });
        items.forEach((item) => observer.observe(item));
      } else {
        items.forEach((item) => item.classList.add('is-visible'));
      }

      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches && !reduceMotion) {
        root.addEventListener('pointermove', (event) => {
          const bounds = root.getBoundingClientRect();
          root.style.setProperty('--vpc-pointer-x', `${event.clientX - bounds.left}px`);
          root.style.setProperty('--vpc-pointer-y', `${event.clientY - bounds.top}px`);
        });
      }
    };

    document.querySelectorAll('[data-vorliva-purchase-confidence]').forEach(initializePurchaseConfidence);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-vorliva-purchase-confidence]').forEach(initializePurchaseConfidence);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
